module.exports = __webpack_public_path__ + "img/im_octopus@2x.0de826a9.jpg";